/* eslint-disable react/require-default-props */
import { Box, FormHelperText, FormHelperTextProps } from '@material-ui/core';
import React, { useMemo } from 'react';
import {
  ControllerFieldState,
  FieldError,
  useController,
} from 'react-hook-form';
import { useFieldControllerContext } from './FieldControllerContext';
import { fieldHasError } from './formUtils';

export type FieldHelperTextProps = FormHelperTextProps & {
  errorMessage?(
    error: FieldError,
    fieldState: ControllerFieldState
  ): React.ReactNode;
  justifyContent?: 'flex-start' | 'flex-end' | 'space-between';
};

const FieldFormHelperText: React.FC<FieldHelperTextProps> = ({
  children,
  justifyContent,
  errorMessage = error => error?.message,
  ...props
}) => {
  const { name, maxLength } = useFieldControllerContext();
  const {
    fieldState,
    field: { value },
  } = useController({ name });

  const hasError = useMemo(() => fieldHasError(fieldState), [fieldState]);

  return (
    <FormHelperText
      component="div"
      id={`${name}-helper-text`}
      error={hasError}
      {...props}
    >
      <Box
        display="flex"
        justifyContent={
          justifyContent ||
          (hasError && maxLength ? 'space-between' : 'flex-end')
        }
      >
        {hasError &&
          (errorMessage
            ? errorMessage(fieldState.error as FieldError, fieldState)
            : fieldState.error?.message)}

        {!hasError && children}

        {maxLength && (
          <Box pl={1}>{`${String(value)?.length}/${maxLength}`}</Box>
        )}
      </Box>
    </FormHelperText>
  );
};

export default FieldFormHelperText;
